define('SageDotCom/DataLayer/Global/product-list-tracker',[
        "jquery",
        "SageDotCom/DataLayer/Events/product-list-button"
    ],
    function ($, ProductListButton) {
        function ProductListTracker() {
            this.scope = $(".product-landing");
            this.button = $(".score-flex-box .flex-item .score-highlight .caption .score-call-to-action .score-button:visible", this.scope);
        }

        ProductListTracker.prototype.start = function () {
            if (!this.button) return;

            this.button.on("click", onClickEvent);

            var productImpressionArray = $(".score-flex-box .flex-item .score-highlight .caption .score-call-to-action .score-button:visible", this.scope);
            if (productImpressionArray.length > 0) {
                $(window).bind("load scroll", function () {
                    for (let i = productImpressionArray.length - 1; i >= 0; i--) {
                        if (isScrolledIntoView(productImpressionArray[i])) {
                            onScrollEvent(productImpressionArray[i]);
                            productImpressionArray.splice(i, 1);
                        }
                    }
                });
            }
        }

        function isScrolledIntoView(elem) {
            var docViewTop = $(window).scrollTop();
            var docViewBottom = docViewTop + $(window).height();

            var elemTop = $(elem).offset().top;
            var elemBottom = elemTop + $(elem).height();
            return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

        function onScrollEvent(e) {
            var eventName = "product_impression";
            new ProductListButton(e, eventName).trigger();
        }

        function onClickEvent(e) {
            var eventName = "product_click";
            new ProductListButton(e.currentTarget, eventName).trigger();
        }

        return ProductListTracker;
    });
